import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

// Inject CSS to completely disable ripple effects as a fallback
const style = document.createElement('style')
style.textContent = `
  /* Completely disable ripple effects */
  .v-ripple__container {
    display: none !important;
  }
  
  .v-ripple__animation {
    display: none !important;
  }

`
document.head.appendChild(style)

export default new Vuetify({
  defaults: {
    global: {
      ripple: false, // This disables ripple for all components that support it
    },
    // Explicitly disable ripple for specific components
    VBtn: {
      ripple: false,
    },
    VCard: {
      ripple: false,
    },
    VListItem: {
      ripple: false,
    },
    VTab: {
      ripple: false,
    },
    VChip: {
      ripple: false,
    },
    VExpansionPanelHeader: {
      ripple: false,
    },
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: colors.blue.darken1,
        secondary: colors.green.base,
        accent: colors.blueGrey.base,
        error: colors.red.base,
        warning: colors.deepOrange.base,
        info: colors.teal.base,
        success: colors.green.base,
        background: colors.grey.darken3,
      },
      dark: {
        primary: colors.shades.white,
        secondary: colors.green.darken3,
        accent: colors.blueGrey.darken3,
        error: colors.red.darken3,
        warning: colors.deepOrange.darken3,
        info: colors.teal.darken3,
        success: colors.green.darken3,
        background: colors.grey.darken3,
      }
    },
  },
  icons: {
    iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  }
})